export default "<abw-page-builder-qrcode-design [model]=\"model\" [value]=\"model.value\"></abw-page-builder-qrcode-design>";